import brand from '@helpers/brand';
import { rgba } from 'polished';
import * as React from 'react';
import { PuffLoader } from 'react-spinners';
import S from './LoadingIndicator.styles';
const LoadingIndicator = (props) => {
    return (React.createElement(S.Loader, { "data-layout": props.layout ?? 'inline', "data-alignment": props.alignment ?? 'center', style: {
            '--bgColour': props.bgColour ?? rgba(brand.primary.blue, 0.66),
            '--fgColour': props.fgColour ?? brand.global.white,
        } },
        React.createElement(PuffLoader, { color: "currentColor", size: props.size ?? 64 }),
        props.label && React.createElement(S.LoaderText, null, props.label)));
};
export default LoadingIndicator;
